//
// Copyright (c) 2023 Emplifi, Inc.
//

import { Command, type ModelDocumentSelection } from "ckeditor5";

export default class AlignFigureCommand extends Command {
  refresh() {
    const model = this.editor.model;
    const element = this._getSelectedModelWidget(model.document.selection);

    this.isEnabled = !!element;
    if (element && element.hasAttribute("figureAlignment")) {
      this.value = element.getAttribute("figureAlignment");
    } else {
      this.value = null;
    }
  }

  execute(alignment: string) {
    const model = this.editor.model;

    model.change((writer) => {
      const requestedStyle = alignment;
      const figureElement = this._getSelectedModelWidget(model.document.selection);

      if (figureElement) {
        if (requestedStyle) {
          writer.setAttribute("figureAlignment", requestedStyle, figureElement);
        } else {
          writer.removeAttribute("figureAlignment", figureElement);
        }
      }
    });
  }

  private _getSelectedModelWidget(selection: ModelDocumentSelection) {
    const selectedElement = selection.getSelectedElement();
    if (
      selectedElement &&
      (selectedElement.is("element", "media") ||
        selectedElement.is("element", "imageBlock") ||
        selectedElement.is("element", "table"))
    ) {
      return selectedElement;
    }
    return null;
  }
}
